// 메시지(민트워치 PTT)는 계정별 CanMessages 권한으로, 지도는 CanMap 권한으로 제어된다.
export const menuItems = [
  { key: "dashboard", label: "대시보드", perm: "CanDashboard" },
  { key: "live", label: "실시간 관제", perm: "CanLiveView" },
  { key: "playback", label: "다시보기", perm: "CanPlayback" },
  { key: "events", label: "이벤트", perm: "CanEvents" },
  // 안전 리포트는 AI(PPE) 결과를 보는 화면이다. AI 를 안 쓰는 회사에는 빈 화면이라 숨긴다.
  { key: "safety-report", label: "안전 리포트", perm: "CanEvents", ppe: true },
  { key: "messages", label: "메시지", perm: "CanMessages", mintwatch: true },
  { key: "map", label: "지도", perm: "CanMap" },
  { key: "devices", label: "장비", perm: "CanDevices" },
];